var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 13.4583V3.54167C19.25 2.7625 18.425 2.125 17.4167 2.125H4.58333C3.575 2.125 2.75 2.7625 2.75 3.54167V13.4583C2.75 14.2375 3.575 14.875 4.58333 14.875H17.4167C18.425 14.875 19.25 14.2375 19.25 13.4583ZM7.79167 9.5625L10.0833 11.6946L13.2917 8.5L17.4167 12.75H4.58333L7.79167 9.5625Z",
    fill: "#508CC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueImagePlaceholder);
export default __webpack_public_path__ + "static/media/blue-image-placeholder.1eb6568aef915ae5646f12bbc256c55b.svg";
export { ForwardRef as ReactComponent };